import React, { useEffect, useState } from 'react';
import { api } from '@/contexts/AuthContext';
import { PhoneCall, Sparkles, Mail, MessageSquare } from 'lucide-react';

const STATS = [
  { key: 'appels', label: 'Appels passés', icon: PhoneCall, color: '#0055FF' },
  { key: 'rdv_obtenus', label: 'RDV obtenus', icon: Sparkles, color: '#10B981' },
  { key: 'emails_envoyes', label: 'Emails envoyés', icon: Mail, color: '#F97316' },
  { key: 'commentaires', label: 'Commentaires', icon: MessageSquare, color: '#8B5CF6' },
];

export default function WeeklySummaryStrip() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/dashboard/weekly-summary')
      .then(r => setData(r.data))
      .catch(() => setData(null));
  }, []);

  if (!data) return null;

  return (
    <div
      className="rounded-xl border border-[#E5E7EB] bg-gradient-to-r from-[#FAFAFA] to-white px-4 py-2.5 flex items-center justify-between flex-wrap gap-3"
      data-testid="weekly-summary-strip"
    >
      <span className="text-[11px] uppercase tracking-wider text-[#71717A] font-semibold flex-shrink-0">
        Activité — 7 derniers jours
      </span>
      <div className="flex items-center gap-5 flex-wrap">
        {STATS.map(s => {
          const Icon = s.icon;
          const value = data[s.key] || 0;
          return (
            <div key={s.key} className="flex items-center gap-2" data-testid={`weekly-stat-${s.key}`}>
              <div
                className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: `${s.color}12`, color: s.color }}
              >
                <Icon className="w-[14px] h-[14px]" />
              </div>
              <div className="leading-none">
                <p className="text-base font-bold tabular-nums" style={{ fontFamily: 'var(--font-heading)', color: s.color }}>
                  {value.toLocaleString('fr-FR')}
                </p>
                <p className="text-[10px] text-[#71717A] mt-0.5">{s.label}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
